import reflection from "csi/reflection";
import { ATTR_PARENT, C8Node } from "csi/typings";
import ToolbarPluginToggleButton from "csi/view/ToolbarPluginToggleButton";
import declare from "dojo/_base/declare";
import ProductType from "src/Apparel/ProductType";

export = declare([ToolbarPluginToggleButton], {

	/**
	 * @override
	 * Show Allocation Toggle button if Product ColorProductSources:Enabled
	 */
	canShowPlugin(): boolean {
		const view = this.getView();
		const viewNode: C8Node = view.getViewNode();
		const nodeClass = reflection.getNodeClass(viewNode);

		if (!nodeClass) {
			return false;
		}

		const product = nodeClass.isDerivedFrom("Product") ? viewNode :
			view.getCache().get(viewNode[ATTR_PARENT]);

		if (!product) {
			return false;
		}

		if (product.IsInspiration || ProductType.get(product, "ColorProductSources") !== "ColorProductSources:Enabled") {
			return false;
		}

		return product["ColorAllocationStatus"] === "ColorAllocationStatus:Off";
	},
});